module.exports = __webpack_public_path__ + "img/exchange-fill.7f265e54.svg";